<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/adminUserManagement"
        >Admin User Management</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">Create Admin User</h3>
    <div class="detailContent">
      <div class="requireRmarks">*Required Fields</div>
      <el-form
        label-width="180px"
        label-position="left"
        ref="formAccount"
        :model="formAccount"
        :rules="formAccountRules"
      >
        <el-row>
          <h4>User Information</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Name" prop="name">
              <el-select v-model="formAccount.name" @change="changeUserInformation()">
                <el-option
                  v-for="(item, index) in userList"
                  :key="index"
                  :label="item.fullName"
                  :value="item.fullName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Last Name">
              <el-input
                v-model="formAccount.lastName"
                maxlength="50"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Email Address">
              <el-input
                v-model="formAccount.email"
                maxlength="50"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="First Name">
              <el-input
                v-model="formAccount.firstName"
                maxlength="50"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="Email address" prop="email">
              <el-input v-model="formAccount.email" maxlength="50"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Password" prop="pwd">
              <el-input v-model="formAccount.pwd" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-divider></el-divider>
        <el-row>
          <h4>Permission</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Level" prop="userLevel">
              <el-select v-model="formAccount.userLevel" @change="changeUserLevel">
                <el-option
                  v-for="(item, index) in userLevelList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Sales Office" prop="salesOffice">
              <el-select
                v-model="formAccount.salesOffice"
                @change="changeSalesOffice"
                :disabled="isSalesOfficeDisabled"
              >
                <el-option
                  v-for="(item, index) in salesOfficeListFiltered"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item
              label="Region"
              prop="regions"
              style="text-align: left"
            >
              <el-checkbox-group
                v-model="formAccount.regions"
                :disabled="isRegionsDisabled"
              >
                <el-checkbox
                  :label="item.code"
                  v-for="(item, index) in regionListFiltered"
                  :key="index"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Permisson">
              <div class="table-box">
                <el-row class="table-head">
                  <el-col :span="8"
                    ><div class="Module"><p>Module</p></div></el-col
                  >
                  <el-col :span="16">
                    <el-row class="vu">
                      <el-col :span="12"
                        ><div class="View"><p>View</p></div></el-col
                      >
                      <el-col :span="12"
                        ><div class="Update"><p>Update</p></div></el-col
                      >
                    </el-row>
                  </el-col>
                </el-row>

                <el-row v-for="(item, i) in tableData" class="table-body">
                  <el-col :span="8"
                    ><div class="Module">
                      <p>{{ item.name }}</p>
                    </div></el-col
                  >
                  <el-col :span="16">
                    <el-row>
                      <el-checkbox-group
                        style="height: 100%"
                        v-model="checkTypeList"
                        @change="handleCheckAllChange"
                      >
                        <el-col
                          class="checkbox"
                          :span="12"
                          v-for="(code, index) in item.codes"
                        >
                          <el-checkbox
                            :label="code"
                            :key="index"
                            @change="handleCheckedCitiesChange"
                            ><p class="none">none</p></el-checkbox
                          >
                        </el-col>
                      </el-checkbox-group>
                    </el-row>
                  </el-col>
                </el-row>

                <!-- <div>
                  <el-checkbox-group v-model="checkTypeList">
                    <el-checkbox
                      class="checkbox"
                      :label="item"
                      v-for="(item, index) in tableData[i].codes"
                      :key="index"
                      ><p class="none">none</p></el-checkbox
                    >
                  </el-checkbox-group>
                </div> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button
          v-if="showSave"
          class="reset"
          style="width: 100%"
          @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          type="primary"
          style="width: 100%"
          @click="handleCreate"
          v-if="showSave"
          >Create</el-button
        >
      </el-col>
    </el-row>
    <!-- Confirm Info -->
    <el-dialog
      :visible.sync="confirmInfoDialog"
      width="430px"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="confirmInfo"
    >
      <h3
        style="
          margin: 0 0 15px;
          font-size: 20px;
          text-align: center;
          font-weight: bold;
        "
      >
        Admin user account is created!
      </h3>
      <p style="font-size: 16px; width: 75%; margin: 0 auto; line-height: 1.5">
        Please copy the following login information and send it to your
        colleagues:
      </p>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :span="12" style="text-align: left"
          ><span style="color: #003448">Email address</span></el-col
        >
        <el-col :span="12" style="text-align: right"
          ><span style="color: #003448">{{ userInfo.email }}</span></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" style="text-align: left"
          ><span style="color: #003448">Password</span></el-col
        >
        <el-col :span="12" style="text-align: right"
          ><span style="color: #003448">{{ formAccount.pwd }}</span></el-col
        >
      </el-row>
      <el-divider></el-divider>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Close</el-button>
        <el-button type="primary" @click="handleCopy">Copy</el-button>
      </div>
    </el-dialog>
    <textarea
      name="copyTxt"
      id="copyTxt"
      v-model="copyTxt"
      style="position: absolute; left: -9999px"
    ></textarea>
  </div>
</template>

<script>
import {
  getSalesOffice,
  getSalesRegion,
  cmsAddUser,
  cmsPermissions,
  employeesCmsuser
} from "@/request/api";
export default {
  name: "cmsCreateUser",
  data() {
    var pwdValidator = (rule, value, callback) => {
      let pattern = this.$commonjs.passwordReg;
      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (pattern.test(value)) {
        if (reg.test(value)) {
          callback(new Error("Password can not contain Chinese"));
        } else {
          callback();
        }
      } else {
        callback(
          new Error(
            "Password length must be 8-20 and contain uppercase, lowercase, numeric and special characters"
          )
        );
      }
    };
    return {
      formAccountRules: this.$validation.cmsUserCreate,
      formAccount: {
        employeId: "",
        userLevel: "",
        salesOffice: "",
        regions: [],
        name: "",
        firstName: "",
        lastName: "",
        initial: "",
        email: "",
        pwd: ""
      },
      checkTypeList: [],
      tableData: [],
      userList: [],
      salesOfficeFullList: [],
      // salesOfficeList:[],
      regionFullList: [],
      // regionList:[],
      userLevelList: [
        { name: "Level 1", code: "SUPER_ADMIN" },
        { name: "Level 2", code: "CS_TEAM" },
        { name: "Level 3", code: "SALES_TEAM" }
      ],
      confirmInfoDialog: false,
      userInfo: {},
      copyTxt: "",
      showSave: true,
      checkPermission: [],
      isCheck: false
    };
  },
  computed: {
    isSalesOfficeDisabled() {
      return this.formAccount.userLevel === "SUPER_ADMIN";
    },
    isRegionsDisabled() {
      return (
        this.formAccount.userLevel === "SUPER_ADMIN" ||
        this.formAccount.userLevel === "CS_TEAM"
      );
    },
    salesOfficeListFiltered() {
      if (this.formAccount.userLevel === "SUPER_ADMIN") {
        return this.salesOfficeFullList;
      } else {
        return this.salesOfficeFullList.filter(s => s.code != "All");
      }
    },
    regionListFiltered() {
      if (
        !this.formAccount.salesOffice ||
        this.formAccount.salesOffice === "All"
      ) {
        return this.regionFullList;
      } else {
        return this.regionFullList.filter(
          r => r.salesOfficeCode === this.formAccount.salesOffice
        );
      }
    }
  },
  watch: {},
  methods: {
    getFilterConfig() {
      getSalesOffice().then(res => {
        const salesOfficeList = res.data.payload;
        salesOfficeList.unshift({ name: "All", code: "All" });
        this.salesOfficeFullList = JSON.parse(JSON.stringify(salesOfficeList));
      });
      getSalesRegion("").then(res => {
        this.regionFullList = JSON.parse(JSON.stringify(res.data.payload));
      });
    },

    handleCheckedCitiesChange(item) {
      this.isCheck = item;
    },

    handleCheckAllChange(val) {
      this.checkPermission.forEach(code => {
        var isRead = false;
        if (this.isCheck) {
          if (
            !val.find(item => item === code + "READ") &&
            val.find(item => item === code + "WRITE")
          ) {
            this.checkTypeList.push(code + "READ");
          }
        } else {
          if (
            !val.find(item => item === code + "READ") &&
            val.find(item => item === code + "WRITE")
          ) {
            this.checkTypeList.forEach((item, index) => {
              if (item === code + "WRITE") {
                this.checkTypeList.splice(index, 1);
              }
            });
          }
        }
      });
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        item => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },

    changeUserInformation() {
      let user = this.userList.filter((item, index, arr) => {
        return item.fullName === this.formAccount.name;
      });
      console.log(user[0]);
      this.formAccount.firstName = user[0].firstName;
      this.formAccount.lastName = user[0].lastName;
      this.formAccount.employeId = user[0].employeeId;
      this.formAccount.email = user[0].email;
    },

    changeUserLevel(v) {
      if (v === "SUPER_ADMIN") {
        this.$set(this.formAccount, "salesOffice", "All");
        this.changeSalesOffice();
      } else if (v === "CS_TEAM") {
        this.$set(this.formAccount, "salesOffice", "");
      }
    },
    changeSalesOffice() {
      this.$set(this.formAccount, "regions", []);
      if (
        this.formAccount.userLevel &&
        this.formAccount.userLevel !== "SALES_TEAM"
      ) {
        this.$set(
          this.formAccount,
          "regions",
          this.regionListFiltered.map(r => r.code)
        );
      }
    },
    handleCancel() {
      this.$router.push("/adminUserManagement");
    },
    handleCreate() {
      this.$refs.formAccount.validate(valid => {
        if (valid) {
          // let params = {
          //   userLevel: this.formAccount.userLevel,
          //   salesOffices: [this.formAccount.salesOffice],
          //   regions: this.formAccount.regions,
          //   firstName: this.formAccount.firstName,
          //   lastName: this.formAccount.lastName,
          //   initial: this.formAccount.initial,
          //   email: this.formAccount.email,
          //   pwd: this.$encryptedRSAOAEP(this.formAccount.pwd),
          // };
          let params = {
            employeeId: this.formAccount.employeId,
            // email: this.formAccount.email,
            salesOffices: [this.formAccount.salesOffice],
            regions: this.formAccount.regions,
            userLevel: this.formAccount.userLevel,
            permissionCode: this.checkTypeList
          };
          console.log(params);
          cmsAddUser(params).then(res => {
            console.log(res);
            if (res.data.status == "00") {
              //this.confirmInfoDialog = true;
              this.handleCancel()
              this.userInfo = res.data.payload;
              this.copyTxt = `email:${this.userInfo.email}\nPassword:${this.formAccount.pwd}`;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error(
            "Please check the form and fill in correct format"
          );
        }
      });
    },

    Employees() {
      employeesCmsuser().then(res => {
        console.log(res);
        const data = res.data.payload;
        this.userList = data;
      });
    },
    Permissions() {
      cmsPermissions().then(res => {
        console.log(res);
        const data = res.data.payload;
        this.tableData = data;
        data.forEach(item => {
          this.checkPermission.push(item.codes[0].split("READ")[0]);
        });
      });
    },
    handleCopy() {
      let el = document.getElementById("copyTxt");
      el.select();
      document.execCommand("Copy");
      this.$message.success("Copy success");
    }
  },
  mounted() {},
  created: function() {
    this.Permissions();
    this.Employees();
    this.getFilterConfig();
    this.$set(this.formAccount, "pwd", this.$commonjs.randomPassword(12));
    this.showBtn("CMS_USER_WRITE");
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.table-box {
}
.table-head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.none {
  display: none;
}

.checkbox {
  text-align: center;
  display: flex;
  margin: 0;
  border-left: 1px solid #ebeef5;
  align-items: center;
  justify-content: center;
}

.Module p {
  padding: 12px 10px;
  text-align: center;
}
.vu {
  display: flex;
  overflow: hidden;
}
.View {
  text-align: center;
  border-left: 1px solid #ebeef5;
}
.Update {
  text-align: center;
  border-left: 1px solid #ebeef5;
}
.View p {
  padding: 12px 0px;
}
.Update p {
  padding: 12px 0px;
}
.table-body {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.table-body p {
  padding: 12px 10px;
}
.el-checkbox-group {
  display: flex;
  overflow: hidden;
}

.el-row {
  margin-bottom: 0;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/cmsUser/createUser.vue